import React, { useEffect, useState, useRef } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
     Chart,
     ChartSeries,
     ChartLegend,
     ChartSeriesItem,
     ChartCategoryAxis,
     ChartCategoryAxisItem,
} from "@progress/kendo-react-charts";
import { useSelector ,useDispatch} from "react-redux";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import {
     timeFormatUtcToLocal,
     getObjectFromArray,
     getDateRangeString,
     showCustomLoading,
} from "../../../../_helpers/support.services";
import ExportToExcelWithApi from "../../../_uiComponents/common/ExportToExcelWithApi";
import  {getEmailTrackingDispatchDownloadRequest} from "../../../../_redux/_actions"
import { dashboardConstants } from "../../../../_redux/_constants";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";

export default function EmailTracking(props) {
     const actionDispatch = useDispatch();
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);
     const [exportData, setExportData] = useState(null);
     const downloadFileName = useRef(null);

    const { dashboardEmailTrackingSummary, loader, dashboardEmailTrackingDownload } = useSelector((state) => {
          return {
               dashboardEmailTrackingSummary:
                    state.dashboard.dashboardEmailTrackingSummary,
                    loader: state.loading,
                    dashboardEmailTrackingDownload: state.dashboard.dashboardEmailTrackingDownload
          };
     });

     const getData = (startDate = null, endDate = null) => {
          downloadFileName.current =
               "email_tracking_failed_stats_" +
               getObjectFromArray(
                    props.applicationId,
                    "value",
                    dashboardConstants.userTypes,
               ).label +
               "_date_" +
               getDateRangeString(startDate, endDate);

          props.getData(startDate, endDate, props.applicationId);
     };

     useEffect(
          function () {
               getData(startDate, endDate);
          },
          [props.applicationId],
     );

       useEffect(()=>{
          setExportData(dashboardEmailTrackingDownload)
     },[dashboardEmailTrackingDownload])

     const fetchDataForExport = async (onDownloadComplete) => {
          try {
          actionDispatch(getEmailTrackingDispatchDownloadRequest({
                    downloadType:"emailtrack",
                    startDate,
                    endDate,
                    applicationId:props.applicationId
               }));
          } catch (error) {
               onDownloadComplete(false);
               console.error("Error fetching data for export:", error);
          }
          };

     return (
          <>
               <div className="sba-chart-top-section sba-line-chart-section sba-line-chart-email-tracking">
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}
                    <h5>Email Tracking</h5>
                    <ExportToExcelWithApi 
                              name={downloadFileName.current}
                              data={exportData}
                              onDownloadClick={(onDownloadComplete) => fetchDataForExport(onDownloadComplete)}
                         />
                    <div className="sba-chart-top-range-picker">
                         <UiDateRangePicker
                              onChange={(value) => {
                                   if (value[0] && value[1]) {
                                        const startDate = timeFormatUtcToLocal(
                                             value[0],
                                        );
                                        const endDate = timeFormatUtcToLocal(
                                             value[1],
                                        );
                                        setStartDate(startDate);
                                        setEndDate(endDate);

                                        getData(startDate, endDate);
                                   } else {
                                        if (!value[0] && !value[1]) {
                                             getData();
                                        }
                                   }
                              }}
                         />
                    </div>
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>
               <div className="sba-email-tracking-top">
                    <div className="sba-email-tracking-top__box">
                         <label>Requests</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-requests">
                                   {
                                        dashboardEmailTrackingSummary?.totalEmailRequests
                                   }
                              </h3>
                         </div>
                    </div>
                    <div className="sba-email-tracking-top__box">
                         <label>Delivered</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-delivered">
                                   {Number(
                                        (
                                             (dashboardEmailTrackingSummary?.totalDeliveredEmails /
                                                  dashboardEmailTrackingSummary?.totalEmailRequests) *
                                             100
                                        ).toFixed(1),
                                   )}
                                   %
                              </h3>
                              <h5>
                                   {
                                        dashboardEmailTrackingSummary?.totalDeliveredEmails
                                   }
                              </h5>
                         </div>
                    </div>
                    <div className="sba-email-tracking-top__box">
                         <label>Opened</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-opened">
                                   {Number(
                                        (
                                             (dashboardEmailTrackingSummary?.totalOpenedEmails /
                                                  dashboardEmailTrackingSummary?.totalEmailRequests) *
                                             100
                                        ).toFixed(1),
                                   )}
                                   %
                              </h3>
                              <h5>
                                   {
                                        dashboardEmailTrackingSummary?.totalOpenedEmails
                                   }
                              </h5>
                         </div>
                    </div>
                    <div className="sba-email-tracking-top__box">
                         <label>Clicked</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-clicked">
                                   {Number(
                                        (
                                             (dashboardEmailTrackingSummary?.totalClickedEmails /
                                                  dashboardEmailTrackingSummary?.totalEmailRequests) *
                                             100
                                        ).toFixed(1),
                                   )}
                                   %
                              </h3>
                              <h5>
                                   {
                                        dashboardEmailTrackingSummary?.totalClickedEmails
                                   }
                              </h5>
                         </div>
                    </div>
                    <div className="sba-email-tracking-top__box">
                         <label>Bounces</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-bounces">
                                   {Number(
                                        (
                                             (dashboardEmailTrackingSummary?.totalBouncedEmails /
                                                  dashboardEmailTrackingSummary?.totalEmailRequests) *
                                             100
                                        ).toFixed(1),
                                   )}
                                   %
                              </h3>
                              <h5>
                                   {
                                        dashboardEmailTrackingSummary?.totalBouncedEmails
                                   }
                              </h5>
                         </div>
                    </div>
                    <div className="sba-email-tracking-top__box">
                         <label>Spam Reports</label>
                         <div className="sba-email-tracking-top__amount">
                              <h3 className="sba-email-tracking-top__amount-spam-report">
                                   {Number(
                                        (
                                             (dashboardEmailTrackingSummary?.totalSpamReportsEmails /
                                                  dashboardEmailTrackingSummary?.totalEmailRequests) *
                                             100
                                        ).toFixed(1),
                                   )}
                                   %
                              </h3>
                              <h5>
                                   {
                                        dashboardEmailTrackingSummary?.totalSpamReportsEmails
                                   }
                              </h5>
                         </div>
                    </div>
               </div>

               <div className="expand-chart">
                    <Chart transitions={false}>
                         <ChartLegend
                              position="bottom"
                              orientation="horizontal"
                         />

                         <ChartCategoryAxis>
                              <ChartCategoryAxisItem
                                   labels={{
                                        rotation: "auto",
                                   }}
                                   categories={
                                        dashboardEmailTrackingSummary?.categories
                                   }
                              />
                         </ChartCategoryAxis>

                         <ChartSeries>
                              {dashboardEmailTrackingSummary?.chartDataList?.map(
                                   (item, idx) => (
                                        <ChartSeriesItem
                                             name={item.name}
                                             type="line"
                                             data={item.values}
                                             tooltip={{ visible: true }}
                                        />
                                   ),
                              )}
                         </ChartSeries>
                    </Chart>
               </div>
          </>
     );
}
